import * as ScreenOrientation from "expo-screen-orientation";
import { OrientationLock } from "expo-screen-orientation";
import { useTheme } from "styled-components/native";

export const useOrientationLock = () => {
  const theme = useTheme();

  return async () => {
    if (theme.isMobile) {
      await ScreenOrientation.lockAsync(OrientationLock.PORTRAIT_UP).then();
    } else {
      await ScreenOrientation.lockAsync(OrientationLock.LANDSCAPE).then();
    }
  };
};
